export enum EConsumptionViewTypes {
  CONSUMED = "CONSUMED",
  SCHEDULED = "SCHEDULED",
  ALL = "ALL",
}
